module.exports = __webpack_public_path__ + "static/img/15.c88cc1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/15.png
// module id = Rb5c
// module chunks = 0